import "./rma-items.scss";
import RmaListItemStore from "../../stores/rma-item-store";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { observer } from "mobx-react";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import ReserveItemsIndicator from "./reserve-items-indicator";

interface IProps {
    rma: RmaListItemStore,
}

const RmaItems: React.FC<IProps> = observer(({ rma }) => {
    const scope = 'dashboard-returns-page';
    const { getTranslation } = useDashboardTranslation();
    const itemsTitle = rma.amount > 1 ? getTranslation('ITEMS', scope) : getTranslation('ITEM', scope);
    return (
        <div className="rma-items-container">
            {rma.reservedItemsInfo && <ReserveItemsIndicator reserveItemsInfo={rma.reservedItemsInfo} />}
            <FontBody2>{rma.amount} {itemsTitle}</FontBody2>
        </div>
    );
});

export default RmaItems;
